<template src="./template.html"></template>

<script>
  import { assign, remove } from 'lodash'
  import vueDropzone from 'vue2-dropzone'
  import Cookie from 'js-cookie'

  export default {
    name: 'FileUploader',
    components: {
      vueDropzone,
    },
    props: {
      config: null,
      headline: {
        type: String,
      },
      changeUploadTitle: Boolean,
    },
    data() {
      return {
        files: [],
        baseConfig: {
          addRemoveLinks: true,
          dictCancelUpload: this.$t('dropzone.actions').cancel_upload || 'cancel',
          dictRemoveFile: this.$t('dropzone.actions').remove_file || 'remove',
          maxFilesize: 20,
          thumbnailHeight: 150,
          thumbnailWidth: 150,
          url: `${process.env.VUE_APP_API_URL}posts/file`,
          headers: {
            'X-CSRF-Token': Cookie.get('intranet_csrf_token') || null,
          },
        },
      }
    },
    computed: {
      fileUploaderConfig() {
        return assign({}, this.baseConfig, this.config)
      },
      uploadTitle() {
        return this.changeUploadTitle ? this.$t('post.file_uploader.title') : this.$t('profile.profile_info.upload_title')
      },
    },
    methods: {
      onPickFile(resp) {
        if (resp.status !== 'success') return
        this.files.push(JSON.parse(resp.xhr.response).id)
        // if (this.config.maxFiles <= this.files.length) this.$refs.dropzone.disable()
        this.$emit('onFilesChanged', this.files)
      },
      onRemoveFile(file) {
        if (file.status !== 'success') return
        const id = JSON.parse(file.xhr.response).id
        remove(this.files, f => f === id)
        // if (this.config.maxFiles > this.files.length) this.$refs.dropzone.enable()
        this.$emit('onFilesChanged', this.files)
      },
      removeFile(file) {
        this.$refs.dropzone.removeFile(file)
      },
      removeAllFiles() {
        this.$refs.dropzone.removeAllFiles(true)
      },
    },
  }
</script>

